import { Redirect, Stack } from 'expo-router';
import { isLeadSourcesEnabled } from '../../../src/lib/featureFlags';
import { colors } from '../../../src/theme/colors';

export const unstable_settings = {
  initialRouteName: 'lead-sources',
};

// Opaque app-base color so screens hide the inactive (mounted) tabs (no bleed)
// and blend with the chrome instead of reading as a separate container.
const contentBackground = colors.background.primary;

export default function LeadSourcesStackLayout() {
  if (!isLeadSourcesEnabled()) {
    return <Redirect href="/dashboard" />;
  }

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: contentBackground },
      }}
    />
  );
}
